import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { User, Package } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../components/ui/breadcrumb";

const SimplePage = ({ type = "conta" }) => {
  const isOrders = type === "pedidos";
  const Icon = isOrders ? Package : User;
  const pageTitle = isOrders ? "Meus Pedidos" : "Minha Conta";
  const [iframeHeight, setIframeHeight] = useState(320);

  const iframeSrc = isOrders
    ? "/wp/index.php/minha-conta/orders/"
    : "/wp/index.php/minha-conta/";

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.data &&
        (event.data.type === "SET_ACCOUNT_HEIGHT" || event.data.type === "SET_CHECKOUT_HEIGHT") &&
        event.data.height >= 200 &&
        event.data.height <= 3000
      ) {
        setIframeHeight(event.data.height);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Início</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{pageTitle}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-200">
        <span className="inline-flex h-10 w-10 rounded-full bg-brand-light items-center justify-center">
          <Icon className="h-5 w-5 text-brand" />
        </span>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
          {pageTitle}
        </h1>
      </div>

      <div className="w-full bg-white transition-all">
        <iframe
          src={iframeSrc}
          style={{ width: "100%", height: `${iframeHeight}px`, border: "none", display: "block" }}
          scrolling="no"
          title={pageTitle}
          sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation allow-popups"
        />
      </div>
    </div>
  );
};

export default SimplePage;
